import { render, staticRenderFns } from "./general-info-view-tab.vue?vue&type=template&id=fdbe41bc&scoped=true"
import script from "./general-info-view-tab.vue?vue&type=script&lang=js"
export * from "./general-info-view-tab.vue?vue&type=script&lang=js"
import style0 from "./general-info-view-tab.vue?vue&type=style&index=0&id=fdbe41bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbe41bc",
  null
  
)

export default component.exports